import api from '../../api/apiRpd'
import actions from './rpdActions'

// Получение направлений подготовки
export const getSpecialtyCodes = () => async (dispatch: any) => {
    const responce = await api.getSpecialtyCodes()

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                dispatch(actions.setSpecialtyCodes(responce.data.itemsData))
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}

// Получение дисцплин
export const getDisciplines = (specialtyCodeID: string) => async (dispatch: any) => {
    const responce = await api.getDisciplines(specialtyCodeID)

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                dispatch(actions.setDisciplines(responce.data.itemsData))
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}

// Получение файлов
export const getFiles = (subjectID: string) => async (dispatch: any) => {
    const responce = await api.getFiles(subjectID)

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                dispatch(actions.setFiles(responce.data.itemsData))
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}



// Создание направления подготовки
export const createSpecialtyCodes = (specialtyCodesName: string, disciplinesList: any) => async (dispatch: any) => {
    const responce = await api.createSpecialtyCodes(specialtyCodesName, disciplinesList)

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                dispatch(getSpecialtyCodes())
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}

// Создание дисциплин
export const createDisciplines = (specialtyCodeID: string, disciplinesList: any) => async (dispatch: any) => {
    const responce = await api.createDisciplines(specialtyCodeID, disciplinesList)

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                dispatch(getDisciplines(specialtyCodeID))
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}

// Загрузка файлов
export const uploadFilesRpd = (file: any, disciplineID: string, fileName: string) => async (dispatch: any) => {
    const responce = await api.uploadFilesRpd(file, disciplineID, fileName)

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                dispatch(getFiles(disciplineID))
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}



// Редактирование направлений подготовки
export const editSpecialty = (specialtyID: string, specialtyName: string) => async (dispatch: any) => {
    const responce = await api.editSpecialty(specialtyID, specialtyName)

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                dispatch(getSpecialtyCodes())
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}

// Редактирование дисциплин
export const editDiscipline = (disciplineID: string, disciplineName: string, specialtyCodeID: string) => async (dispatch: any) => {
    const responce = await api.editDiscipline(disciplineID, disciplineName)

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                dispatch(getDisciplines(specialtyCodeID))
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}



// Удаление направлений подготовки
export const deleteSpecialty = (specialtyID: string, specialtyName: string) => async (dispatch: any) => {
    const responce = await api.deleteSpecialty(specialtyID, specialtyName)

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                dispatch(getSpecialtyCodes())
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}

// Удаление дисциплин
export const deleteDiscipline = (disciplineID: string, disciplineName: string, specialtyCodeID: string) => async (dispatch: any) => {
    const responce = await api.deleteDiscipline(disciplineID, disciplineName)

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                dispatch(getDisciplines(specialtyCodeID))
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}

// Удаление файлов
export const deleteFile = (fileID: string, fileName: string, subjectID: string) => async (dispatch: any) => {
    const responce = await api.deleteFile(fileID, fileName)

    if (!responce.code) {
        switch (responce.data.statusCode) {
            case 'OK': // Все ОК
                dispatch(getFiles(subjectID))
                return { code: 'OK' }

            default: return { code: responce.data.statusCode }
        }
    } else {
        return { code: "ERR_NETWORK" } // API сервер не доступен
    }
}



// Очистка направлений подготовки
export const clearSpecialtyCodes = () => (dispatch: any) => {
    dispatch(actions.setSpecialtyCodes([]))
}

// Очистка дисциплин
export const clearDisciplines = () => (dispatch: any) => {
    dispatch(actions.setDisciplines([]))
}

// Очистка файлов
export const clearFiles = () => (dispatch: any) => {
    dispatch(actions.setFiles([]))
}